var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { role: "main" } }, [
    _c("h1", [_vm._v(_vm._s(_vm.$t("ChangeRequests.Title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("ChangeRequests.PageInfo")))]),
    _vm._v(" "),
    _c("h2", [_vm._v(_vm._s(_vm.$t("ChangeRequests.RequestTypes.Title")))]),
    _vm._v(" "),
    _c("p", [
      _c("b", [
        _vm._v(
          _vm._s(_vm.$t("ChangeRequests.RequestTypes.DeadlineChange")) + ":"
        )
      ]),
      _vm._v(
        " " +
          _vm._s(_vm.$t("ChangeRequests.RequestTypes.DeadlineChange_Details")) +
          "\n  "
      )
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn btn-secondary mb-3",
        attrs: { type: "button" },
        on: {
          click: function($event) {
            return _vm.startDeadlineChange()
          }
        }
      },
      [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("ChangeRequests.StartDeadlineChange")) +
            "\n  "
        )
      ]
    ),
    _vm._v(" "),
    _c("p", [
      _c("b", [
        _vm._v(
          _vm._s(_vm.$t("ChangeRequests.RequestTypes.PurposeChange")) + ":"
        )
      ]),
      _vm._v(
        " " +
          _vm._s(_vm.$t("ChangeRequests.RequestTypes.PurposeChange_Details")) +
          "\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _c("b", [
        _vm._v(_vm._s(_vm.$t("ChangeRequests.RequestTypes.TargetChange")) + ":")
      ]),
      _vm._v(
        " " +
          _vm._s(_vm.$t("ChangeRequests.RequestTypes.TargetChange_Details")) +
          "\n  "
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }